import * as React from "react";

export default class ErrorBoundary extends React.Component {
  state = {
    hasError: false,
    error: "",
  };

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
  }

  render() {
    if (this.state.hasError) {
      return <pre>{this.state.error}</pre>;
    }

    return this.props.children;
  }
}
